module.exports = __webpack_public_path__ + "static/media/cb-4.e762ff20.png";